import { render, staticRenderFns } from "./SupportActionsButton.vue?vue&type=template&id=483a6da9&"
import script from "./SupportActionsButton.vue?vue&type=script&lang=js&"
export * from "./SupportActionsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports